/**
 * Created by mqamhieh on 11/20/16.
 */
window.WorkEligibilityForm = function(scope, options, applicationId) {
    var self = this;
    var formName = "work-eligibility-form";
    var _protected = BaseForm.call(self, formName, scope);

    self.status = options;
    self.applicationId = applicationId;

    for (var i in options) {
        if (options[i].selected) {
            self.data.status = options[i].code;
        }
    }

    self.load = function () {};

    self.getPreparedData = function () {
        var optionSelected = options.find(function (option) {
            return (option.code === self.data.status);
        });
        return ({"option_id": optionSelected.id});
    };

    self.setApplicationId = function (applicationId) {
        self.applicationId = applicationId;
    };

    self.save = function () {
        return JobApplicationAPI.saveWorkEligibility(self.applicationId, self.data.status);
    }
};